require('./advancedBuySellStockSummary.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @hconstants
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_RESTRICTED_ORDER_TERM,
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    BROKER_STOCK_ORDER_CONDITION_VALUE,
    BROKER_INPUT_SEARCH_STOCKS_TYPE,
    BROKER_IBEX35_STOCK_MARKET_NAME,
    BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID,
    BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INDEX_ORDER_CONDITION_VALUE,
    MAX_FRACTION_LENGTH_IN_STORE
} = require('constants/index');

// @commons
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

class AdvancedBuySellStockSummary extends React.Component {
    getOrderTermsDescription(unit) {
        const { immBrokerStocksAdvancedState, immSearchState } = this.props;
        const step1 = immBrokerStocksAdvancedState.get('steps').get(FIRST_STEP);
        const orderTerms = step1.get('orderTerms');
        const orderConditionValue = step1.get('orderConditionValue');
        const stockId = step1.get('stockId');
        const conditionType = step1.get('conditionType');
        let conditionTypeValue;

        let result;

        if (orderTerms === BROKER_RESTRICTED_ORDER_TERM) {
            result = (
                <FormattedText value="broker-advancedBuySellStockSummaryOrderTermsDescription" />
            );
        } else {
            let name;

            if (orderConditionValue === BROKER_STOCK_ORDER_CONDITION_VALUE) {
               const searchList = immSearchState
                    .get('results')
                    .filter(entry => {
                        return (
                            entry.get('type') === BROKER_INPUT_SEARCH_STOCKS_TYPE &&
                            entry.get('value') === stockId
                        );
                    })
                if (!!searchList && !!searchList.get(0)) {
                    name = searchList.get(0).get('label');
                } else {
                    name = BROKER_IBEX35_STOCK_MARKET_NAME;
                }
            } else {
                name = BROKER_IBEX35_STOCK_MARKET_NAME;
            }

            unit = unit.toLowerCase();

            switch (conditionType) {
                case BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = (
                        <FormattedText
                            value="broker-priceGraterOrEqualOrderTermsDescription"
                            injectedStrings={[name, conditionTypeValue, unit]}
                        />
                    );
                    break;
                case BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = <FormattedText value="broker-priceLessOrEqualOrderTermsDescription" injectedStrings={[name, conditionTypeValue, unit]} />
                    break;
                case BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = <FormattedText value="broker-dailyLoweringPercentageGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue]} />
                    break;
                case BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = <FormattedText value="broker-dailyRasingPercentageGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue]} />
                    break;
                case BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = <FormattedText value="broker-intradayDownVariationGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue, unit]} />
                    break;
                case BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = <FormattedText value="broker-intradayDownVariationPercentageGraterThanOrderTermsDescription" injectedStrings={[name, conditionTypeValue]} />
                    break;
                case BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(
                        step1.get('conditionTypeValue'),
                        undefined,
                        MAX_FRACTION_LENGTH_IN_STORE
                    );
                    result = (
                        <FormattedText
                            value="broker-intradayUpVariationGraterThanOrderTermsDescription"
                            injectedStrings={[name, conditionTypeValue, unit]}
                        />
                    );
                    break;
                case BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                    conditionTypeValue = formatAmount(step1.get('conditionTypeValue'));
                    result = (
                        <FormattedText
                            value="broker-intradayUpVariationPercentageGraterThanOrderTermsDescription"
                            injectedStrings={[conditionTypeValue]}
                        />
                    );
                    break;
                default:
                    result = (
                        <div>
                            {name}
                        </div>
                    );
                    break;
            }
        }

        return (
            <div className="advanced-buy-sell-stock-summary__order-terms-block">
                {result}
            </div>
        );
    }

    render() {
        const {
            immProductFile,
            immBrokerStocksAdvancedState,
            immStocksContract,
            modifier
        } = this.props;
        const step1 = immBrokerStocksAdvancedState.get('steps').get(FIRST_STEP);
        const step2 = immBrokerStocksAdvancedState.get('steps').get(SECOND_STEP);
        const selectedOptionValue = immBrokerStocksAdvancedState.getIn([
            'steps',
            SECOND_STEP,
            'selectedOptionValue'
        ]);

        let stockContract;
        let summaryTitleTranslationKey;

        if (modifier === 'buy') {
            summaryTitleTranslationKey = 'advancedSellStockSummaryPurchaseOrderSummaryTitle';
            stockContract = immStocksContract.get(selectedOptionValue);
        } else {
            summaryTitleTranslationKey = 'advancedBuySellStockSummarySellOrderSummaryTitle';
            stockContract = immStocksContract.find(contract => {
                return contract.get('contactNumber') === selectedOptionValue;
            });
        }

        if (!stockContract) {
            return null;
        }

        const orderTerms = immBrokerStocksAdvancedState
            .get('steps')
            .get(FIRST_STEP)
            .get('orderTerms');
        const orderConditionValue = immBrokerStocksAdvancedState.getIn([
            'steps',
            FIRST_STEP,
            'orderConditionValue'
        ]);

        let orderTermsText = formatText('broker-advancedBuySellStockSummaryConditionalOrder');
        let orderTermsDescription = this.getOrderTermsDescription(
            orderConditionValue === BROKER_INDEX_ORDER_CONDITION_VALUE
                ? formatText('broker-pointsText')
                : formatText('currencies-EUR')
        );

        if (orderTerms === BROKER_RESTRICTED_ORDER_TERM) {
            orderTermsText = formatText('broker-advancedBuySellStockSummaryRestrictedOrder');
        }

        return (
            <div className="advanced-buy-sell-stock-summary">
                <OKInformativeList>
                    <OKInformativeListItem
                        title={formatText('broker-advancedBuySellStockSummaryOrderTypeText')}
                        bodyText={orderTermsText}
                        isUppercaseTitle={true}
                        className="advanced-buy-sell-stock-summary__order-terms-title"
                    >
                        {orderTermsDescription}
                    </OKInformativeListItem>
                </OKInformativeList>
                <FormattedText
                    value={`broker-${summaryTitleTranslationKey}`}
                    className="advanced-buy-sell-stock-summary__purchase-order-summary-title"
                />
                <StocksBuySellSummary
                    productName={formatText('broker-stockProductName')}
                    productCurrency={immBrokerStocksAdvancedState.get('productCurrency')}
                    stockContract={stockContract}
                    stockDescription={immProductFile.get('companyName')}
                    step1={step2}
                    step1Real={step1}
                    modifier={modifier}
                    productIso={immProductFile.get('micCode')}
                />
            </div>
        );
    }
}

AdvancedBuySellStockSummary.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerStocksAdvancedState: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired,
    modifier: PropTypes.oneOf([
        BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
        BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER
    ])
};

module.exports = AdvancedBuySellStockSummary;
